<nz-spin [nzSpinning]="calendarLoading"  class="calendar-container">
    <div #calendarTable>
        <div class="filter-container">
            <div class="switch-day">
                <ng-container *ngIf="needRangeSwitch && calendarMode === 'month'">
                    <nz-button-group class="btn-group">
                        <button nz-button nzType="default" (click)="changeMonth('pre')">
                            <i nz-icon nzType="left"></i>
                            Pre Month
                        </button>
                        <button nz-button nzType="default" (click)="changeMonth('next')">
                            Next Month
                            <i nz-icon nzType="right"></i>
                        </button>
                    </nz-button-group>
                </ng-container>
                <ng-container *ngIf="calendarMode === 'day'">
                    <nz-button-group class="btn-group">
                        <button nz-button nzType="default" [disabled]="getDisabled('pre')" (click)="changeDay('pre')">
                            <i nz-icon nzType="left"></i>
                            Pre Day
                        </button>
                        <button nz-button nzType="default" [disabled]="getDisabled('next')" (click)="changeDay('next')">
                            Next Day
                            <i nz-icon nzType="right"></i>
                        </button>
                    </nz-button-group>
                </ng-container>
            </div>
            <div *ngIf="calendarMode === 'day'" class="center-date">
                {{ getDayRange() }}
            </div>

            <div *ngIf="calendarMode === 'month' && dateList.length > 0" class="center-date">
                {{ dateList[0] | date: 'YYYY-MM-dd' }} - {{ dateList[dateList.length - 1] | date: 'YYYY-MM-dd' }}
            </div>

            <div class="right-container">
                <app-tab-button [currentIndex]="currentIndex" [tabs]="tabs" (change)="changeView($event)"></app-tab-button>
            </div>
        </div>

        <nz-table
            [nzShowPagination]="false"
            [nzData]="tableData"
            nzBordered
            [nzScroll]="tableData.length > 0 ? nzScroll : { x: '300px' }"
            [nzFrontPagination]="false"
            (mouseleave)="tableMouseLeave()"
            [nzLoading]="loading || requestLoading"
            class="table"
            #table
            (mouseleave)="changeMenuVisible(false)"
        >
            <thead>
            <tr>
                <th *ngIf="hasEyes && menuColumns?.length > 0" [nzLeft]="true" nzWidth="50px" scope="col" class="head-eyes">
            <span nz-icon nzType="eye" nzTheme="outline" class="eyes-icon"
                  (mouseenter)="changeMenuVisible(true)"></span>
                </th>
                <th [nzLeft]="true" class="un-select header-title" nzWidth="180px">
                    <div>
                        <label
                            class="check-all"
                            *ngIf="needCheckBox"
                            nz-checkbox
                            [(ngModel)]="allChecked"
                            (ngModelChange)="updateAllChecked()"
                            [nzIndeterminate]="indeterminate"
                        >
                        </label>
                        Resource
                    </div>
                    <i
                        nz-icon
                        nzType="question-circle"
                        nzTheme="outline"
                        nz-popover
                        nzPopoverOverlayClassName="calendar-popover"
                        style="font-size: 22px;"
                        [nzPopoverContent]="legendTemplate"
                    ></i>
                </th>

                <ng-template #legendTemplate>
                    <app-calendar-legend></app-calendar-legend>
                </ng-template>
                <ng-container *ngFor="let column of displayedColumns">
                    <th [nzWidth]="column?.width || '100px'" [nzLeft]="true" style="padding: 10px">
                        {{ column.label }}
                    </th>
                </ng-container>
                <th
                    nzWidth="60px"
                    *ngFor="let item of dateList, let i = index"
                    class="un-select date-th"
                    [class]="getHeaderColor(item)"
                    [nzAlign]="calendarMode === 'day' ? 'left' : 'center'"

                    (click)="changeDayView(item)" [ngClass]="{ 'date-header': calendarMode === 'month' }">
                    <ng-container *ngIf="calendarMode === 'day'">
                        {{item | date: 'h a'}}
                    </ng-container>

                    <ng-container *ngIf="calendarMode === 'month'">
                        <div>
                            {{item | date: 'E'}}
                        </div>
                        {{item | date: 'MM-dd'}}
                    </ng-container>
                </th>
                <th nzWidth="80px" *ngIf="canEdit && tableData.length > 0" [nzRight]="true"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of tableData; let i = index;" class="table-tr">
                <td *ngIf="hasEyes && menuColumns?.length > 0" [nzLeft]="true"></td>
                <td [nzLeft]="true" class="un-select resource-name"
                    [class]="!!highlightId && (highlightId === data?.hardwareId || highlightId === data?.value?.toString()) ? 'highlight-name' : ''"
                    (mousedown)="$event.preventDefault()">
                    <label *ngIf="needCheckBox" nz-checkbox [(ngModel)]="data.checked" (ngModelChange)="changeCheckOne()"
                           class="name-check"></label>
                    <app-overflow-tooltip
                        [class]="needCheckBox ? 'min-resource-text' : 'max-resource-text'"
                        [text]="data.name"
                        [html]="data.name"
                    ></app-overflow-tooltip>
                </td>
                <ng-container *ngFor="let column of displayedColumns">
                    <td [nzLeft]="true" style="padding: 10px"
                    >
                        <app-overflow-tooltip
                            [text]="getValueByPath(data, column.index, column, i)"
                            [html]="getValueByPath(data, column.index, column, i)"
                        ></app-overflow-tooltip>
                    </td>
                </ng-container>
                <ng-container *ngFor="let cell of data.dateList;">
                    <td
                        [nzAlign]="'center'"
                        nz-popover
                        nzPopoverOverlayClassName="calendar-popover"
                        [nzPopoverContent]="hasTaskInfo(cell) || cell.hasRequest ? contentTemplate : ''"
                        [ngClass]="{
                     'select-cell': selectDate.includes(data.id + '_' + cell.date),
                     'weekend-cell': cell.isWeekend,
                     'different-cell': cell.isDifferentTask,
                     'conflict-cell': cell.hasConflict,
                     'request-cell': cell.hasRequest
                    }"
                        class="table-td"
                        (mousedown)="mouseDown($event, data, cell)"
                        (mouseenter)="mouseEnter($event, data, cell)"
                        (mouseup)="mouseUp($event)"
                        [class]="getColor(cell)"
                    >
                        <div *ngIf="cell.isSomeHour" class="half-cell"></div>
                    </td>
                    <ng-template #contentTemplate>
                        <div class="popover-container">
                            <div *ngFor="let taskItem of cell?.task, let j = index" class="popover-item">
                                <div *ngIf="taskItem.name" class="label">
                                    <div>
                                        <span class="label-text">Project:</span>{{taskItem.projectName}}
                                    </div>
                                    <div>
                                        <span class="label-text">Project Prime:</span>{{taskItem.projectPrimeName}}
                                    </div>
                                    <div>
                                        <span class="label-text">Task:</span>{{taskItem.name}}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="cell.hasRequest" class="request-box">
                                <a (click)="toRequest(data)">Pending Resource Request</a>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <td [nzAlign]="'center'" [nzRight]="true" class="un-select remove-padding"
                    (mousedown)="$event.preventDefault()"
                    *ngIf="canEdit && tableData.length > 0">
                    <button nz-button nzSize="small" class="edit-button text-btn-primary" (click)="edit(data)">Edit</button>
                </td>
            </tr>
            </tbody>
            <div *ngIf="menuVisible" class="head-menu" (mouseleave)="changeMenuVisible(false)" (mouseenter)="menuVisible = true">
                <nz-psin [nzSpinning]="menuLoading">
                    <div class="menu-item first-item">
                        <label
                            nz-checkbox
                            [(ngModel)]="allColumnsChecked"
                            (ngModelChange)="updateColumnChecked()"
                            [nzIndeterminate]="allColumnsIndeterminate"
                            class="menu-label"
                        >
                            Show/Hide Columns
                        </label>
                    </div>
                    <div *ngFor="let item of menuColumns; let i = index" class="menu-item">
                        <label nz-checkbox [(ngModel)]="item.checked" (ngModelChange)="updateSingleColumnChecked()" class="menu-label">
                            {{ item.label || ''}}
                        </label>
                    </div>
                    <div class="apply-btn" class="menu-item last-item">
                        <button nz-button nzType="primary" (click)="apply()" [nzLoading]="applyLoading">Apply</button>
                    </div>
                </nz-psin>
            </div>
        </nz-table>
    </div>

</nz-spin>

<app-edit-reservation #editDialog [taskDetail]="taskDetail" (submitSuccess)="refresh()"
                      [resourceType]="resourceType"></app-edit-reservation>
